// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"54":"cd03e5b2","60":"e2a9195d","397":"e61f8ae0","547":"65243193","665":"db8207ec","679":"d5d8138e","745":"853fa3d8","951":"1b0668a1"}[chunkId] + ".css";
};